import { SendOutlined } from "@ant-design/icons";
import { Button, Card, QRCode, Space, Tag, Typography } from "antd";

interface TelegramLinkCardProps {
  telegramId?: number | null;
  telegramUsername?: string | null;
  botUsername?: string;
}

const TelegramLinkCard = ({
  telegramId,
  telegramUsername,
  botUsername = "aismetrica_bot",
}: TelegramLinkCardProps) => {
  const botLink = `https://t.me/${botUsername}`;
  const isLinked = Boolean(telegramId);

  if (isLinked) {
    return (
      <Card size="small" title="Telegram" style={{ maxWidth: 400 }}>
        <Space orientation="vertical" size="small">
          <Tag color="green">Привязан</Tag>
          {telegramUsername ? (
            <Typography.Link href={`https://t.me/${telegramUsername}`} target="_blank">
              @{telegramUsername}
            </Typography.Link>
          ) : (
            <Typography.Text type="secondary">ID: {telegramId}</Typography.Text>
          )}
        </Space>
      </Card>
    );
  }

  return (
    <Card size="small" title="Telegram" style={{ maxWidth: 400 }}>
      <Space orientation="vertical" size="middle" align="center" style={{ width: "100%" }}>
        <Typography.Text type="secondary">
          Привяжите аккаунт для получения уведомлений и OTP
        </Typography.Text>
        <QRCode value={botLink} size={160} />
        <Button type="link" icon={<SendOutlined />} href={botLink} target="_blank">
          Открыть @{botUsername}
        </Button>
      </Space>
    </Card>
  );
};

export default TelegramLinkCard;
